import React, { useRef, useEffect, useState } from 'react';
import { FaReact, FaPhp, FaWordpress } from 'react-icons/fa';
import { SiTailwindcss, SiFigma, SiFirebase } from 'react-icons/si';

export default function Competences() {
  const skills = [
    { icon: FaReact, label: 'React' },
    { icon: SiTailwindcss, label: 'Tailwind' },
    { icon: FaPhp, label: 'PHP' },
    { icon: FaWordpress, label: 'Wordpress' },
    { icon: SiFigma, label: 'Figma' },
    { icon: SiFirebase, label: 'Firebase' },
  ];

  // Référence pour le conteneur défilant
  const marqueeRef = useRef(null);
  // Stocker la largeur d'une copie de la liste
  const [copyWidth, setCopyWidth] = useState(0);
  // State pour gérer la taille de l'écran
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  // Fonction pour calculer la largeur de la copie
  const calculateCopyWidth = () => {
    if (marqueeRef.current) {
      // La liste est dupliquée, donc la largeur d'une copie est la moitié du scrollWidth total
      setCopyWidth(marqueeRef.current.scrollWidth / 2);
    }
  };

  // Fonction pour obtenir la taille d'icône selon la largeur d'écran
  const getIconSize = () => {
    if (screenWidth < 640) return 16; // mobile
    if (screenWidth < 768) return 20; // sm
    return 24; // md et plus
  };

  useEffect(() => {
    calculateCopyWidth();
    
    // Recalculer lors du redimensionnement de la fenêtre
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setTimeout(calculateCopyWidth, 100); // Petit délai pour s'assurer que le DOM est mis à jour
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {/* Conteneur responsive avec largeurs adaptatives */}
      <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl overflow-hidden">
        <div
          ref={marqueeRef}
          className="flex whitespace-nowrap"
          style={{
            animation: copyWidth ? `marquee 15s linear infinite` : 'none'
          }}
        >
          {skills.concat(skills).map((skill, index) => {
            const Icon = skill.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-1 px-2 sm:px-3 md:px-4 py-1 bg-white border border-blue-700 text-blue-700 rounded-full text-sm sm:text-base md:text-lg mx-1 sm:mx-2 flex-shrink-0"
              >
                <Icon size={getIconSize()} />
                <span className="font-medium">{skill.label}</span>
              </div>
            );
          })}
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${copyWidth}px); }
        }
      `}</style>
    </>
  );
}
